import * as React from 'react';

const Arrow = React.forwardRef((props, ref) => {
  const {
          className,
          onClick,
          type,
        } = props;

  const icon = React.useMemo(() => {
    switch (type) {
      case 'next':
        return 'ic-arrow-right';

      case 'prev':
        return 'ic-arrow-left';
    }
  }, [type]);

  return (
    <span
      className={`${className} ${icon}`}
      onClick={onClick}
      ref={ref}
    />
  );
});

export default Arrow;